import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Login from "./pages/Login/Login.js"
import PrivateRoute from "./components/PrivateRoute.jsx"
import Main from "./pages/Main/Main.js"
import Test from "./Test.js"
import styles from './App.module.css'
function App() {
  return (
    <div className={styles.App}>
      <Router>
        <Routes>
          {/* 登录页无需认证 */}
          <Route path="/login" element={<Login />} />
          <Route path="/test" element={<Test />} />
          {/* 以下所有路由都被 PrivateRoute 包裹 */}
          <Route element={<PrivateRoute />}>
            <Route path="/" element={<Main />} />
          </Route>
          {/* 兜底：未匹配到且已登录，则 404；未登录，则跳 login */}
          <Route
            path="*"
            element={
              localStorage.getItem('jwt') ? (
                <div>404 Not Found</div>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        </Routes>
      </Router>
    </div >
  );
}
export default App;
